const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner" />
  </div>
);

export default Spinner;